
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Forum from "../pages/forum/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/forum",
    element: <Forum />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
